import queryString from 'query-string';

// it converts react-router path like `/:tenantCode/something/:id/show` to `/utmost/something/1/show`
export function getRouterUrl(url: string, ...args: string[]): string {
  let result: string = '';

  let i = 0;
  url.split('/').forEach((urlPart) => {
    if (!urlPart) {
      return;
    }
    result += '/';
    if (urlPart.startsWith(':')) {
      result += args[i];
      i++;
    } else {
      result += urlPart;
    }
  });
  return result;
}

export function toSearchParamsString<T extends Partial<Record<string, any>>>(
  params?: T,
  arrayFormat?: 'bracket' | 'index' | 'comma' | 'separator' | 'bracket-separator' | 'none',
  excludeCustomParameters?: string[]
): string {
  if (!params) {
    return '';
  }
  const result: Record<string, string | string[]> = {};
  Object.keys(params).forEach((key) => {
    if ((params[key] !== null || params[key] !== undefined) && !excludeCustomParameters?.includes(key)) {
      if (Array.isArray(params[key])) {
        result[key] = params[key].map((arr: any) => JSON.stringify(arr));
      } else if (typeof params[key] === 'object' && params[key] instanceof Date) {
        result[key] = new Date(params[key]).toISOString();
      } else if (typeof params[key] === 'object') {
        result[key] = JSON.stringify(params[key]);
      } else {
        result[key] = `${params[key]}`;
      }
    }
  });
  return queryString.stringify(result, { arrayFormat: arrayFormat || 'bracket' });
}
